import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

import { LgdTextComponent } from "./lgdText.component";
import { ForgeModule } from "@tylertech/forge-angular";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ForgeModule,
    ],
    declarations: [LgdTextComponent],
    exports: [
        ReactiveFormsModule,
        LgdTextComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LgdTextModule { }
